import MetersInfoForm from "./meters-info-form";
import MetersInfoSummary from "./meters-info-summary";
import ContractInfoForm from "./contract-info-form";
import ContractInfoSummary from "./contract-info-summary";
import DocumentationInfo from "./documentation-info-form";
import DocumentationInfoSummary from "./documentation-info-summary";

export const formSteps = [
  {
    name: "Contract Info",
    description: "Information about shipment",
    accessor: "contractInfo",
    FormComponent: ContractInfoForm,
    SummaryComponent: ContractInfoSummary,
  },
  {
    name: "Documentation Info",
    description: "Information about required documentation",
    accessor: "documentationInfo",
    FormComponent: DocumentationInfo,
    SummaryComponent: DocumentationInfoSummary,
  },
  {
    name: "Meters Info",
    description: "Information about meters",
    accessor: "metersInfo",
    FormComponent: MetersInfoForm,
    SummaryComponent: MetersInfoSummary,
  },
];

export default formSteps;
